module.exports = __webpack_public_path__ + "static/media/Phonecover1024page4.31ad4e33.png";